<div class="card-body autopass-container">


    <div class="row">
        <div class="validation-input-container" *ngIf="filter">
            <div>
              <label>FILTER NAME </label>
              <input nz-input type="text" id="validtionFilterNameId" [(ngModel)]="filter.FilterName" />
            </div>

            <div>
              <label>PRIORITY </label>
              <input nz-input type="text" id="validtionFilterPriority" [(ngModel)]="filter.Priority" />
            </div>        
        </div>

        <query-builder 
          id="queryBuilder"
          [RuleType]="RuleType"
          (onfilter)="onfetchMoreData($event)"
          [formControl]='queryCtrl' 
          [config]='config' 
          [allowRuleset]='allowRuleset' 
          [allowCollapse]='allowCollapse'  
          [DataTypeBuilder]="dataTypeBuilder"
          [DataTypeParent]="dataTypeParent"
          [DataTypeChildren]="dataTypeChildren"
          [DefaultDataType]="DefaultDataType"          
          [persistValueOnFieldChange]='persistValueOnFieldChange'>
      
            <ng-container *queryInput="let rule; type: 'textarea'; let getDisabledState=getDisabledState">
              <textarea class="text-input ct-textarea" [(ngModel)]="rule.value" [disabled]=getDisabledState() ></textarea>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'currency'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="true"           
                  [searchable]="true"
                  [multiple]="false"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  class="currency-list">
                  <ng-option *ngFor="let list of listsCurrency"  [value]="list.name">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'multiple-custom-invoice-status'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="false"           
                  [searchable]="true"
                  [multiple]="true"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  class="multiple-list">
                  <ng-option *ngFor="let list of config?.fields['invoicestatusvalidatelist']['options']"  [value]="list.value">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'invoicesource'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="true"           
                  [searchable]="true"
                  [multiple]="true"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  class="invoice-source-list"
                  bindLabel="value">
                  <ng-option *ngFor="let list of listsInvoiceSource"  [value]="list.value">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'reasoncode'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="true"           
                  [searchable]="true"
                  [multiple]="false"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  (scrollToEnd)="onfetchMoreReasonCodes()"
                  class="currency-list">
                  <ng-option *ngFor="let list of listsReasonCodes"  [value]="list.name">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

      </query-builder>
      
      <!-- <pre>
        {{ queryNew | json }}
      </pre> -->

    </div>

    <div class="row bottom-controls">
       <div class="apf-controls">
          <button class="ctgfa-btn ctgfa-confirm-btn" (click)="saveAsFilter()"> <i class="fa fa-save"></i> Save As New</button>
          <button id="validationSaveId" class="ctgfa-btn ctgfa-primary-btn" (click)="saveAutopass(queryNew)"> <i class="fa fa-save"></i> Save</button>
       </div>
    </div>

</div>
